import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const CarListingPage = () => {
  const [filters, setFilters] = useState({
    priceRange: "",
    fuelType: "",
    transmission: "",
    searchQuery: "",
  });

  const [carData, setCarData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCars = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        "http://192.168.29.147:5000/api/global/user/get-all-car",
        {
          params: {
            ...filters,
            page: 1, // You can implement pagination later
            limit: 10,
          },
        }
      );
      console.log(response);

      if (response.status === 200) {
        setCarData(response.data.data.data);
      }

      // Adjust based on the API response structure
    } catch (err) {
      setError("Failed to fetch cars. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch cars when component mounts or filters change
  useEffect(() => {
    fetchCars();
  }, [filters]);

  // const toggleDetails = (id) => {
  //   setCarData((prevCars) =>
  //     prevCars.map((car) =>
  //       car._id === id ? { ...car, showDetails: !car.showDetails } : car
  //     )
  //   );
  // };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(price);
  };

  const renderStars = (rating) => {
    return Array(5)
      .fill(0)
      .map((_, i) => (
        <svg
          key={i}
          className={`w-4 h-4 ${
            i < Math.floor(rating) ? "text-amber-500" : "text-gray-300"
          }`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ));
  };

  const clearFilters = () => {
    setFilters({
      priceRange: "",
      fuelType: "",
      transmission: "",
      searchQuery: "",
    });
  };

  const filteredCars = carData.filter((car) => {
    if (
      filters.searchQuery &&
      !`${car.brand} ${car.model}`
        .toLowerCase()
        .includes(filters.searchQuery.toLowerCase())
    ) {
      return false;
    }
    if (filters.priceRange) {
      const [min, max] = filters.priceRange.split("-").map(Number);
      if (car.price < min || car.price > max) return false;
    }
    if (filters.fuelType && car.fuelType !== filters.fuelType) {
      return false;
    }
    if (filters.transmission && car.transmission !== filters.transmission) {
      return false;
    }
    return true;
  });

  const hasActiveFilters =
    filters.searchQuery ||
    filters.priceRange ||
    filters.fuelType ||
    filters.transmission;

  return (
    <div className="bg-gray-50 min-h-screen p-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Find Your Perfect Car
          </h1>
          <p className="text-gray-600">
            Discover amazing deals on quality pre-owned vehicles
          </p>
        </div>

        {/* Filters */}
        <div className="mb-6 bg-white rounded-lg shadow-sm p-6">
          <div className="flex flex-col lg:flex-row gap-4">
            {/* Search */}
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Search Cars
              </label>
              <div className="relative">
                <input
                  type="text"
                  name="searchQuery"
                  placeholder="Search by make or model"
                  value={filters.searchQuery}
                  onChange={handleFilterChange}
                  className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors"
                />
              </div>
            </div>

            {/* Price Range */}
            <div className="min-w-0 flex-shrink-0 lg:w-48">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Price Range
              </label>
              <select
                name="priceRange"
                value={filters.priceRange}
                onChange={handleFilterChange}
                className="block w-full pl-3 pr-10 py-3 text-base border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 rounded-lg transition-colors"
              >
                <option value="">All Prices</option>
                <option value="0-500000">Under ₹5L</option>
                <option value="500000-1000000">₹5L - ₹10L</option>
                <option value="1000000-1500000">₹10L - ₹15L</option>
                <option value="1500000-2000000">₹15L - ₹20L</option>
              </select>
            </div>

            {/* Fuel Type */}
            <div className="min-w-0 flex-shrink-0 lg:w-40">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Fuel Type
              </label>
              <select
                name="fuelType"
                value={filters.fuelType}
                onChange={handleFilterChange}
                className="block w-full pl-3 pr-10 py-3 text-base border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 rounded-lg transition-colors"
              >
                <option value="">All Types</option>
                <option value="Petrol">Petrol</option>
                <option value="Diesel">Diesel</option>
              </select>
            </div>

            {/* Transmission */}
            <div className="min-w-0 flex-shrink-0 lg:w-40">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Transmission
              </label>
              <select
                name="transmission"
                value={filters.transmission}
                onChange={handleFilterChange}
                className="block w-full pl-3 pr-10 py-3 text-base border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 rounded-lg transition-colors"
              >
                <option value="">All Types</option>
                <option value="Manual">Manual</option>
                <option value="Automatic">Automatic</option>
              </select>
            </div>
          </div>

          {/* Clear Filters Button */}
          {hasActiveFilters && (
            <div className="mt-4 pt-4 border-t border-gray-200">
              <button
                onClick={clearFilters}
                className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors"
              >
                Clear All Filters
              </button>
            </div>
          )}
        </div>

        {/* Loading and Error Handling */}
        {loading && <p>Loading cars...</p>}
        {error && <p className="text-red-500">{error}</p>}

        {/* Results Count */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800">
            {filteredCars.length} {filteredCars.length === 1 ? "Car" : "Cars"}{" "}
            Available
          </h2>
          {hasActiveFilters && (
            <p className="text-sm text-gray-600 mt-1">
              Showing filtered results
            </p>
          )}
        </div>

        {/* Car Listings */}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredCars.map((car) => (
            <Link to={`/booking/carlisting/details/${car._id}`}>
              <div
                key={car._id}
                className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-gray-200"
              >
                {/* Car Image */}

                <div className="h-48 overflow-hidden bg-gray-200">
                  <img
                    src={car.images[0]} // Adjust based on the API response structure
                    alt={`${car.brand} ${car.model}`}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    onError={(e) => {
                      e.target.src =
                        "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjY0IiBoZWlnaHQ9IjM3NCIgdmlld0JveD0iMCAwIDY2NCAzNzQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI2NjQiIGhlaWdodD0iMzc0IiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0zMzIgMTg3QzM2MS4yNzMgMTg3IDM4NSAyMTAuNzI3IDM4NSAyNDBDMzg1IDI2OS4yNzMgMzYxLjI3MyAyOTMgMzMyIDI5M0MzMDIuNzI3IDI5MyAyNzkgMjY5LjI3MyAyNzkgMjQwQzI3OSAyMTAuNzI3IDMwMi43MjcgMTg3IDMzMiAxODdaIiBmaWxsPSIjOUI5QjlCIi8+Cjx0ZXh0IHg9IjMzMiIgeT0iMjQ1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjNjY2NjY2IiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiPkNhciBJbWFnZTwvdGV4dD4KPC9zdmc+";
                    }}
                  />
                </div>
                {/* Car Info */}
                <div className="p-5">
                  <div className="flex justify-between items-start mb-3">
                    <h3 className="text-xl font-bold text-gray-800 leading-tight">
                      {car.brand} {car.model}
                    </h3>
                    <span className="text-2xl font-bold text-amber-600 ml-2">
                      {formatPrice(car.price)}
                    </span>
                  </div>

                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center">
                      {renderStars(car.rating)}{" "}
                      {/* Adjust based on the API response structure */}
                      <span className="text-gray-500 text-sm ml-2">
                        {car.rating}/5
                      </span>
                    </div>
                    <span className="text-sm text-gray-500 bg-gray-100 px-2 py-1 rounded">
                      {car.year}
                    </span>
                  </div>

                  <div className="grid grid-cols-2 gap-3 mb-4">
                    <div className="flex items-center text-sm text-gray-600">
                      <span>{car.mileage} km</span>{" "}
                      {/* Adjust based on the API response structure */}
                    </div>
                    <div className="flex items-center text-sm text-gray-600">
                      <span>{car.fuelType}</span>
                    </div>
                    <div className="flex items-center text-sm text-gray-600 col-span-2">
                      <span>{car.transmission}</span>
                    </div>
                  </div>

                  <Link
                    to={`/booking/carlisting/details/${car._id}`}
                    className="w-full py-3 px-4 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-medium rounded-lg transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2"
                  >
                    {car.showDetails ? "Hide Details" : "View Details"}
                  </Link>

                  {/* Expanded Details */}
                  {car.showDetails && (
                    <div className="mt-5 pt-5 border-t border-gray-200 animate-fade-in">
                      <h4 className="font-semibold text-gray-700 mb-3">
                        Key Features:
                      </h4>
                      <ul className="space-y-2">
                        {car.features.map((feature, index) => (
                          <li key={index} className="flex items-center">
                            <svg
                              className="w-4 h-4 text-amber-500 mr-3 flex-shrink-0"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                            <span className="text-gray-600 text-sm">
                              {feature}
                            </span>
                          </li>
                        ))}
                      </ul>
                      <div className="mt-4 pt-4 border-t border-gray-100">
                        <button className="w-full py-2 px-4 bg-white border-2 border-amber-500 text-amber-600 font-medium rounded-lg hover:bg-amber-50 transition-colors duration-300">
                          Contact Seller
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* No Results */}
        {filteredCars.length === 0 && !loading && (
          <div className="text-center py-16 bg-white rounded-lg shadow-sm">
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              No cars found
            </h3>
            <p className="text-gray-500 mb-4">
              We couldn't find any cars matching your criteria
            </p>
            {hasActiveFilters && (
              <button
                onClick={clearFilters}
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-amber-600 hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 transition-colors"
              >
                Clear All Filters
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default CarListingPage;
